module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.swiperFlag),
      expression: "swiperFlag"
    }],
    staticClass: "bigDiv"
  }, [_c('coupon-download', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downloadFlag),
      expression: "downloadFlag"
    }],
    staticClass: "downloadBgDiv"
  }), _vm._v(" "), _c('div', {
    staticClass: "downloadDiv"
  }, [_c('img', {
    attrs: {
      "src": _vm.downloadImg
    },
    on: {
      "click": _vm.download
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "posterDiv"
  }, [_c('img', {
    attrs: {
      "src": _vm.coupon.shareImageUrl
    }
  })]), _vm._v(" "), _c('couponTip', {
    attrs: {
      "title": "商品简介"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bannerDiv"
  }, [(_vm.swiperFlag) ? _c('coupon-swiper', {
    attrs: {
      "banners": _vm.coupon.banners
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('couponTip', {
    attrs: {
      "title": "商品详情"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detailDiv"
  }, _vm._l((_vm.coupon.details), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517ae6a1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardCoupons/cottonCoupons.vue
// module id = 453
// module chunks = 1